import Swiper, {Navigation} from 'swiper';
import * as linkify from "linkifyjs"
import linkifyHtml from "linkify-html"

Swiper.use([Navigation])

// DOMContentLoaded ラッパ（旧 @roots/sage/client の domReady 相当）
const domReady = (fn) => {
  if (document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

class Carousel {
  constructor (selector) {
    const isSP = window.innerWidth <= 600
    this.name = selector
    this.$carousel = $(selector)
    this.carouselLeft = 0
    if(/\/kibun\/.*/.test(window.location.pathname)) {
      this.step = (isSP ? -0.5 : -0.75)
    } else {
      this.step = (isSP ? -0.7 : -1.4)
    }
  }
  update () {
    if(!this.$carousel.position()) {
      return
    }
    let val = this.$carousel.position().left + this.step
    const leftMin = this.$carousel.innerWidth() / -2
    if(val < leftMin) {
      val = 0
    }
    else if(0 < val) {
      val = leftMin
    }
    this.carouselLeft = val
  }
  draw () {
    this.$carousel.css('left', `${this.carouselLeft}px`)
  }
}

/**
 * app.main
 */
const main = async () => {
  // application code

  document.isEdge = navigator.userAgent.match(/edg/i)
  if (document.isEdge) {
    $('html').addClass('edge')
  }

  // ブラウザのUIを考慮したビューポートの高さをcssに受け渡す
  // 初期値
  document.documentElement.style.setProperty('--vh-initial', window.innerHeight + 'px')
  document.documentElement.style.setProperty('--vw-initial', window.innerWidth + 'px')
  var setVH = function () {
    // 常に更新
    document.documentElement.style.setProperty('--vh', window.innerHeight + 'px')
    document.documentElement.style.setProperty('--vw', window.innerWidth + 'px')
  }
  $(window).on('resize', setVH)
  setVH()

  // Sticky Auto Hide Header
  const header = document.querySelector('#globalHeader')
  let wScrollBefore = 0
  const threshold = 3
  $(window).on('scroll', function() {
    const pageYOffset = Math.max(0, window.pageYOffset) // iOSの慣性スクロールで負の値になってしまわないように
    const wScrollDiff = wScrollBefore - pageYOffset
    if (threshold <= Math.abs(wScrollDiff)) {
      if (0 <= wScrollDiff) {
        header.classList.add('visible')
      } else {
        header.classList.remove('visible')
      }
    }
    wScrollBefore = pageYOffset
  })



  // ハンバーガーメニュー
  $(document).on('click', '#ham, .modalBackground', function () {
    $('#ham').toggleClass('open')
    const gnav_visibility = $('#ham').hasClass('open')
    $('#globalHeader')
      .css('top', gnav_visibility ? '0' : '')
      .attr('data-sp_menu_visibility', gnav_visibility)
    $('body')
      .toggleClass('spMenuVisible', gnav_visibility)
  })

  // pageTopボタン
  $(document).on('click', '.pageTop', () => {
    $('html, body').animate({
      scrollTop: 0,
    }, 1000)
  })
  // 追従バナーの表示切り替え
  const setPageTopVisiblity = () => {
    const windowBottom = window.pageYOffset + window.innerHeight
    $('.pageTop').toggleClass('visible', 1600 <= windowBottom)
  }
  $(window).on('scroll', setPageTopVisiblity)
  setPageTopVisiblity()

  // ----------- Custom Events -----------
  const THRESHOLD = 500;
  let timeoutId;
  let resizing = false;
  const $win = $(window);
  $win.on('resize', function () {
    var timeout = function () {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(function () {
        resizing = false
        $win.trigger('resizeEnd')
      }, THRESHOLD)
    }
    if (!resizing) {
      resizing = true
      $win.trigger('resizeStart')
    }
    timeout()
  })
  // ----------- Custom Events -----------
  // リサイズ時にSPメニューが見えないようにする
  $(window).on('resizeStart', () => {
    $('#gnav').addClass('noTransition')
  })
  $(window).on('resizeEnd', () => {
    $('#gnav').removeClass('noTransition')
  })

  // ---------------------------------
  // ダウンロードゲート
  // ---------------------------------
  const downloadGate = {
    overlay: document.getElementById('download-gate'),
    titleEl: document.getElementById('download-gate-title'),
    currentFileUrl: null,
    currentFileName: null,

    init() {
      if (!this.overlay) return

      // モーダルを開く: .js-download-gate クリック
      $(document).on('click', '.js-download-gate', (e) => {
        e.preventDefault()
        const $link = $(e.currentTarget)
        // data-file-url はBase64エンコード済み
        try { this.currentFileUrl = atob($link.data('file-url')) } catch (err) { this.currentFileUrl = $link.data('file-url') }
        const fileName = $link.data('file-name') || ''
        const fileTitle = $link.data('file-title') || fileName
        this.currentFileName = fileName
        this.open(fileTitle)
      })

      // モーダルを閉じる: 閉じるボタン / 背景（ダイアログ外）クリック
      $(this.overlay).on('click', (e) => {
        if (e.target === this.overlay || $(e.target).hasClass('download-gate-bg') || $(e.target).hasClass('download-gate-close') || $(e.target).closest('.download-gate-close').length) {
          this.close()
        }
      })

      // ESCキーで閉じる
      $(document).on('keydown', (e) => {
        if (e.key === 'Escape' && this.overlay.style.display !== 'none') {
          this.close()
        }
      })

      // 必須フィールド入力状態に応じて送信ボタンの active 切り替え
      const updateSubmitState = () => {
        const form = this.overlay.querySelector('.wpcf7-form')
        if (!form) return
        const submit = form.querySelector('input[type="submit"]')
        if (!submit) return
        const selects = form.querySelectorAll('select[aria-required="true"]')
        const allFilled = Array.from(selects).every(s => s.selectedIndex > 0)
        submit.classList.toggle('active', allFilled)
      }
      $(this.overlay).on('change', 'select', updateSubmitState)

      // CF7 送信完了 → ファイルダウンロード発火
      // wpcf7mailsent（メール送信成功）または wpcf7mailfailed（メール送信失敗だがバリデーション通過）
      // いずれもCFDB7にはデータ保存済みなのでダウンロードを許可
      const triggerDownload = () => {
        if (!this.currentFileUrl) return
        const a = document.createElement('a')
        a.href = this.currentFileUrl
        a.download = this.currentFileName ? this.currentFileName + '.pdf' : ''
        a.target = '_blank'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        setTimeout(() => this.close(), 500)
      }
      document.addEventListener('wpcf7mailsent', triggerDownload)
      document.addEventListener('wpcf7mailfailed', triggerDownload)
    },

    open(fileName) {
      // タイトル設定
      if (this.titleEl) this.titleEl.textContent = fileName
      // hidden フィールドにドキュメント名とURLをセット
      const hiddenData = this.overlay.querySelector('input[name="data"]')
      if (hiddenData) hiddenData.value = fileName
      const hiddenFileUrl = this.overlay.querySelector('input[name="file_url"]')
      if (hiddenFileUrl) hiddenFileUrl.value = this.currentFileUrl || ''
      // フォームリセット
      const form = this.overlay.querySelector('.wpcf7-form')
      if (form) {
        form.querySelectorAll('select').forEach(s => { s.selectedIndex = 0 })
        form.querySelectorAll('input[type="text"]').forEach(i => { i.value = '' })
        const responseOutput = form.querySelector('.wpcf7-response-output')
        if (responseOutput) responseOutput.setAttribute('aria-hidden', 'true')
        const submit = form.querySelector('input[type="submit"]')
        if (submit) submit.classList.remove('active')
      }
      // iOSでのフォーカス時ズームを防止
      const vp = document.querySelector('meta[name="viewport"]')
      if (vp) this._origViewport = vp.getAttribute('content')
      if (vp) vp.setAttribute('content', (this._origViewport || '') + ',maximum-scale=1')
      // 表示
      this.overlay.style.display = ''
      document.body.classList.add('download-gate-open')
    },

    close() {
      // viewportを元に戻す
      const vp = document.querySelector('meta[name="viewport"]')
      if (vp && this._origViewport) vp.setAttribute('content', this._origViewport)
      this.overlay.style.display = 'none'
      document.body.classList.remove('download-gate-open')
      this.currentFileUrl = null
    }
  }
  downloadGate.init()

  // ヘッダーのランダムアイコン
  const iconNum = Math.floor(Math.random() * 3)
  $('.random-icon').find('img').eq(iconNum).addClass('show')

  // カルーセル関係
  function shuffleContent(container) {
    var content = container.find("> *");
    var total = content.length;
    content.each(function() {
      content.eq(Math.floor(Math.random() * total)).prependTo(container);
    });
  }
  function initCarousels(selectors) {
    const carousels = [];
    selectors.forEach(selector => {
      shuffleContent($(selector)) // ランダムに並び替え
      $(selector+'>*').clone().appendTo(selector) // 繰り返し可能にするために複製
      carousels.push(new Carousel(selector))
    })
    if(carousels.length) {
      // しあわせ点数の理由のフレームレート
      // 気分調査の詳細ページは２行なので、速くしない
      setInterval(() => {
        carousels.forEach((c) => {
          c.update()
          c.draw()
        })
      }, 15)
    }
  }
  // ---------------------------------
  // ページごと
  // ---------------------------------
  if (document.body.classList.contains('home')) {
    // カルーセル
    initCarousels(['#happinessScoreReason'])

    //slider
    var that = $('.custom-slider')
    var allSlides = that.find('.slide')
    var originalSlideNum = allSlides.length
    if (!$('.slide[data-status="current"]').length) {
      that.append(allSlides.clone())
    }
    var allSlides = that.find('.slide')
    var allSlidesNum = allSlides.length
    var currentSlide = 1
    var timer = ''
    var dotsStrings = ''
    var skip = 0
    if (!$('.slide[data-status="current"]').length) {
      for(var i = 0; i < originalSlideNum; i++) {
        dotsStrings += '<span></span>'
      }
      $('.slider-dots').append(dotsStrings)
      $('.slider-dots span').click(function(){
        clearInterval(timer)
        if($(this).index() + 1 > currentSlide) {
          that.attr('data-direction', 'forward')
        }else{
          that.attr('data-direction', 'back')
        }
        var count = $(this).index() + 1 - currentSlide
        if(currentSlide > originalSlideNum){
          count = count + originalSlideNum
        }
        if(count == 1) {
          goToNext()
          startTimer()
        }else if(count == -1){
          goToPrev()
          startTimer()
        }else if(count >= 2) {
          skip = count
          goToNext()
        }else if (count <= -2) {
          skip = count
          goToPrev()
        }else{
          startTimer()
        }
      })
    }

    function slide(){
      var current = currentSlide - 1
      var next = current + 1
      if(next > allSlidesNum - 1){
        next = 0
      }
      if(allSlidesNum >= 3){
        var nextnext = next + 1
        if(nextnext > allSlidesNum - 1){
          nextnext = 0
        }
      }
      prev = current - 1
      if(current < 1){
        var prev = allSlidesNum - 1
      }
      var dot = 0
      if (originalSlideNum < currentSlide) {
        dot = currentSlide - originalSlideNum
      }else{
        dot = currentSlide
      }
      $('.slider-dots').attr('data-dot-status', dot)
      allSlides.attr('data-status', '')
      allSlides.eq(prev).attr('data-status','prev')
      allSlides.eq(current).attr('data-status','current')
      allSlides.eq(next).attr('data-status','next')
      allSlides.eq(nextnext).attr('data-status','nextnext')
      $('[data-current-dots]').attr('data-current-dots', $('[data-status="current"]').attr('data-slide') )
      if(skip > 1) {
        skip--;
        setTimeout(function(){
          goToNext()
        }, 400)
      }else if(skip < -1){
        skip++;
        setTimeout(function(){
          goToPrev()
        }, 400)
      }else if(Math.abs(skip) == 1) {
        startTimer()
      }
    }
    function startTimer(){
      skip = 0
      timer = setInterval(function(){
        that.attr('data-direction', 'forward')
        currentSlide++
        if(currentSlide > allSlidesNum){
          currentSlide = 1
        }
        if(currentSlide < 1){
          currentSlide = allSlidesNum
        }
        slide()
      }, 4500)
    }
    that.addClass('is-init')
    slide()
    that[0].offsetHeight // force reflow so the initial position is applied without a transition
    that.removeClass('is-init')
    startTimer()


    $('.slider-button').click(function(){
      clearInterval(timer)
      var button = $(this)
      skip = 0
      if(button.hasClass('slider-next-button')) {
        goToNext()
      }else{
        goToPrev()
      }

      startTimer()
    })

    function goToNext() {
      that.attr('data-direction', 'forward')
      currentSlide++;
      if(currentSlide > allSlidesNum){
        currentSlide = 1
      }
      slide()
    }
    function goToPrev() {
      that.attr('data-direction', 'back')
      currentSlide--;
      if(currentSlide < 1){
        currentSlide = allSlidesNum
      }
      slide()
    }

    var heroSlider = $('.cards-slider')

    heroSlider.on('touchstart', function(event){
      onTouchStart(event)
    })
    heroSlider.on('touchmove', function(event){
      onTouchMove(event)
    })
    heroSlider.on('touchend', function(event){
      onTouchEnd(event)
    })

    var direction = ''
    var position = ''

    function onTouchStart(event){
      position = getPosition(event)
      direction = ''
    }

    function onTouchMove(event){
      var movePosition = getPosition(event)
      if (Math.abs(position - movePosition) > 120){
        direction = "right"
        if (position > movePosition) {
          direction = 'left'
        }
      } else {
        direction = ''
      }
    }
    function onTouchEnd(event){
      position = ''
      if (direction == 'right'){
        clearInterval(timer)
        goToPrev()
        startTimer()
      }else if (direction == 'left'){
        clearInterval(timer)
        goToNext()
        startTimer()
      }else{
      }
      direction = ''
    }

    function getPosition(event){
      return event.originalEvent.touches[0].pageX
    }
    function fitSize(){
      if($(window).width() < 768){
        var height = [];
        $('.custom-slider .slide').each(function(){
          height.push($(this).height())
        })
        $('.cards-slider').height(Math.max.apply(null, height)+30+6+17+11+5)
      }
    }
    function blowserJudge(){
      const agent = window.navigator.userAgent.toLowerCase()
      var blowser = '';
      if (agent.indexOf("msie") != -1 || agent.indexOf("trident") != -1) {
        console.log("ブラウザはInternet Explorerです。")
      } else if (agent.indexOf("edg") != -1 || agent.indexOf("edge") != -1) {
        console.log("ブラウザはEdgeです。")
      } else if (agent.indexOf("opr") != -1 || agent.indexOf("opera") != -1) {
        console.log("ブラウザはOperaです。")
      } else if (agent.indexOf("chrome") != -1) {
        console.log("ブラウザはChromeです。")
      } else if (agent.indexOf("safari") != -1) {
        console.log("ブラウザはSafariです。")
        blowser = 'safari'
      } else if (agent.indexOf("firefox") != -1) {
        console.log("ブラウザはFireFoxです。")
      } else if (agent.indexOf("opr") != -1 || agent.indexOf("opera") != -1) {
        console.log("ブラウザはOperaです。")
      }
      return blowser;
    }
    function slideTitlesAdjust(){
      var blowser = blowserJudge();
      heroSlider.find('.slide .card').each(function(){
        var that =$(this)
        if(that.find('.title').outerWidth(true) - 24 > that.find('.title span').outerWidth(true) || that.find('.title span').outerHeight(true) < 35 || blowser != 'safari'){
          that.find('.title').addClass('hide')
        }else {
          that.find('.title').removeClass('hide')
        }
      })
    }
    fitSize()
    slideTitlesAdjust()
    $(window).on('resize', function(){
      fitSize()
      slideTitlesAdjust()
    })



    //ここまでHEROエリア処理

    const swiper = new Swiper('.article-wrapper.swiper', {
      loop: false,
      slidesPerView: 'auto',
      slidesPerGroupAuto: 1,
      spaceBetween: 15,
      simulateTouch: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  }
  if (document.body.classList.contains('single-kibun')) {
    // カルーセル
    initCarousels(['#happinessScoreReason_shogaku','#happinessScoreReason_chugaku'])

    // 追従ナビゲーションの表示切り替え
    const setVisiblity = () => {
      // 415pxは、header > .prev, .next が画面外に出る位置
      $('#floatingNav').toggleClass('visible', 415 <= window.scrollY)
    }
    $(window).on('scroll', setVisiblity)
    setVisiblity()

    // チャート部分はVue側に集約
  }
  if (document.body.classList.contains('about')) {
    $(window).on('scroll', () => {
      var $win = $(window),
        winH = $win.height(),
        winW = $win.width(),
        current_pos = $win.scrollTop(),
        current_btm = current_pos + winH;
      $('.scroll-in').each(function(){
        if($(this).offset().top < current_btm - winH/6){
          $(this).addClass('show');
        }
      })
    })
  }
  if (document.body.classList.contains('single-topics')) {
    const options = {
      className: 'autolink',
      target: '_blank',
      defaultProtocol: "https" };
    var text = linkifyHtml(
      $('.article-content').html(),
      options
    );
    $('.article-content').html(text)
    $('a.autolink').each(function(){
      var href = $(this).attr('href');
      if (href.indexOf(document.domain) != -1 && href.indexOf('/arinomama/') == -1) {
        $(this).attr('target', '_self')
      }
    })

    // Findings
    const $head_for_findings = $('.article-content .head_for_findings')
    if ($head_for_findings.length) {
      let html = '<div class="findings"><h4>Findings</h4><ul>'
      $head_for_findings.each(function (i) {
        const index = i + 1
        const id = `findings-${index}`
        // 目次への追加
        html += `<li><a href="#${id}"><span class="num">${index}<span class="dot">.</span></span><span class="text">${$(this).text()}</span></a></li>`
        // 数字の割り付け
        $(this).attr('id', id).find('.num').html(index)
      })
      html += '</ul></div>'
      // Findings要素の追加
      $(html).insertBefore($head_for_findings[0])
      // スクロールアニメーション
      $(document).on('click', '.findings a[href^="#"]', function (e) {
        e.preventDefault()
        $('html, body').animate({
          scrollTop: $($(this).attr('href')).offset().top - 20,
        }, 1000)
      })
    }
  }

    //定点2023,2024,2025共通
    if (document.body.classList.contains('teiten2024') || document.body.classList.contains('teiten2023') || document.body.classList.contains('teiten2025')) {
      const nav = document.querySelector('.page-nav')
      const globalHeader = document.getElementById('globalHeader')
      const pastSurveys = document.querySelector('.past-surveys')
      const badgeWrap = document.getElementById('badge-wrap')
      const badge = document.getElementById('badge')

      // ページ内ナビスクロール
      if (nav && globalHeader && pastSurveys) {
        const placeholder = document.createElement('div')
        placeholder.style.display = 'none'
        nav.parentNode.insertBefore(placeholder, nav)

        let initialNavTop = nav.offsetTop

        const updateNavDimensions = () => {
          const navTop = nav.offsetTop
          const navHeight = nav.offsetHeight
          const navBottom = navTop + navHeight
          const globalHeaderHeight = globalHeader.offsetHeight
          const pastSurveysHeight = pastSurveys.offsetHeight
          return { navTop, navHeight, navBottom, globalHeaderHeight, pastSurveysHeight }
        }

        const setPlaceholderHeight = () => {
          placeholder.style.height = window.innerWidth > 1023 ? '69px' : '154px'
        }

        const toggleFixedNav = () => {
          const { globalHeaderHeight } = updateNavDimensions()
          let adjustedNavTop = initialNavTop
          if (window.innerWidth <= 1023 && globalHeader.classList.contains('visible')) {
            adjustedNavTop -= globalHeaderHeight
          }
          if (window.scrollY >= initialNavTop) {
            nav.classList.add('fixed')
            placeholder.style.display = 'block'
            nav.style.top = '0'
            if (window.innerWidth <= 1023) {
              pastSurveys.style.display = 'none'
            }
          } else {
            if (window.scrollY < (window.innerWidth <= 1023 ? adjustedNavTop : initialNavTop)) {
              nav.classList.remove('fixed')
              nav.style.position = ''
              nav.style.top = ''
              placeholder.style.display = 'none'
              if (window.innerWidth <= 1023) {
                pastSurveys.style.display = 'flex'
              }
            }
          }
        }

        const adjustNavPosition = () => {
          const { navBottom, globalHeaderHeight } = updateNavDimensions()
          if (window.innerWidth <= 1023 && window.scrollY >= navBottom) {
            nav.style.top = globalHeader.classList.contains('visible') ? `${globalHeaderHeight - 1}px` : '0'
          } else {
            nav.style.top = '0'
          }
        }

        const handleScroll = () => {
          toggleFixedNav()
          adjustNavPosition()
        }

        const handleResize = () => {
          if (nav.classList.contains('fixed')) {
            initialNavTop = placeholder.offsetTop
          } else {
            initialNavTop = nav.offsetTop
          }

          setPlaceholderHeight()
          handleScroll()
          if (window.innerWidth > 1023) {
            pastSurveys.style.display = 'flex'
          } else {
            if (window.scrollY >= initialNavTop) {
              pastSurveys.style.display = 'none'
            } else {
              pastSurveys.style.display = 'flex'
            }
          }
        }

        window.addEventListener('scroll', _.throttle(handleScroll, 400))
        window.addEventListener('resize', _.throttle(handleResize, 400))

        // バッジのスムーススクロール
        const badgeSelector = document.body.classList.contains('teiten2023') ? '#badge' : ''
        const selector = `.page-nav a[href^="#"], small a[href^="#"], .lead a[href^="#"], .anchor-banner${badgeSelector ? `, ${badgeSelector}` : ''}`

        document.querySelectorAll(selector).forEach(link => {
          link.addEventListener('click', function(event) {
            event.preventDefault()
            const target = document.getElementById(this.getAttribute('href').substring(1))
            if (target) {
              const { globalHeaderHeight, pastSurveysHeight } = updateNavDimensions()
              const isGlobalHeaderVisible = globalHeader.classList.contains('visible')
              let offset = nav.offsetHeight

              if (window.innerWidth <= 1023) {
                if (isGlobalHeaderVisible) {
                  offset += globalHeaderHeight - 1
                }
                offset -= pastSurveysHeight
              }

              const currentScrollPosition = window.scrollY
              const targetPosition = target.offsetTop - offset

              if (window.innerWidth <= 1023) {
                if (targetPosition < currentScrollPosition) {
                  offset = globalHeaderHeight + nav.offsetHeight - pastSurveysHeight - 1
                }

                if (targetPosition > currentScrollPosition && isGlobalHeaderVisible) {
                  offset -= globalHeaderHeight
                }
              }

              window.scrollTo({
                top: target.offsetTop - offset,
                behavior: 'smooth'
              })
            }
          })
        })

        setPlaceholderHeight()
        handleScroll()
      }

      // バッジの追従
      const setBadgePosition = () => {
        if (!badge || !badgeWrap || window.getComputedStyle(badge).display === 'none') return

          const badgeWrapRect = badgeWrap.getBoundingClientRect()
          const windowHeight = window.innerHeight
          const windowWidth = window.innerWidth
          const mainContentMaxWidth = 1588
          const contentPadding = Math.max(Math.round((windowWidth - mainContentMaxWidth) / 2), 0)

          if (badgeWrapRect.bottom > windowHeight) {
            badge.style.position = 'fixed'
            badge.style.right = windowWidth > mainContentMaxWidth ? `${contentPadding + 27}px` : '35px'
          } else {
            badge.style.position = 'absolute'
            badge.style.right = '35px'
          }
      };

      document.addEventListener('scroll', setBadgePosition)
      window.addEventListener('resize', setBadgePosition)

      setBadgePosition()
    }

    // 定点2024　アコーディオン切り替え機能
    if (document.body.classList.contains('teiten2024')) {
      const accordionButtons = document.querySelectorAll('.all-graph[data-accordion]');

      accordionButtons.forEach(button => {
        button.addEventListener('click', function() {
          const accordionId = this.getAttribute('data-accordion');
          const accordionContent = document.getElementById(`accordion-${accordionId}`);

          if (accordionContent) {
            const isActive = accordionContent.classList.contains('active');

            if (!isActive) {
              accordionContent.classList.add('active');
              this.classList.add('active');
              const textNode = this.childNodes[0];
              if (textNode.nodeType === Node.TEXT_NODE) {
                textNode.textContent = '閉じる';
              }
            } else {
              accordionContent.classList.remove('active');
              this.classList.remove('active');
              const textNode = this.childNodes[0];
              if (textNode.nodeType === Node.TEXT_NODE) {
                textNode.textContent = '全てのグラフを見る';
              }

              const buttonTop = this.offsetTop;
              const windowHeight = window.innerHeight;
              const buttonHeight = this.offsetHeight;
              const offsetFromBottom = 100;
              const targetPosition = buttonTop - windowHeight + buttonHeight + offsetFromBottom;

              window.scrollTo({
                top: targetPosition
              });
            }
          }
        });
      });
    }

    // 定点2025　グラフ一覧スライダー（画面幅が狭くなったら横スクロール化）
    if (document.body.classList.contains('teiten2025')) {
      document.querySelectorAll('.graph-list').forEach(list => {
        const track = list.querySelector('.graph-track')
        const prevButton = list.querySelector('.graph-prev-button')
        const nextButton = list.querySelector('.graph-next-button')
        const cards = track ? track.querySelectorAll('.graph-wrap') : []
        if (!track || !prevButton || !nextButton || !cards.length) return

        let index = 0
        let syncTimer = null

        const getMaxScrollLeft = () => track.scrollWidth - track.clientWidth
        // 1枚目カードのmargin-leftが、画面左端からのメインカード基準位置(35px/20px)になる
        const getInset = () => parseFloat(getComputedStyle(cards[0]).marginLeft) || 0

        const updateButtons = () => {
          prevButton.classList.toggle('is-disabled', index <= 0)
          nextButton.classList.toggle('is-disabled', index >= cards.length - 1)
        }

        const goTo = (newIndex) => {
          index = Math.max(0, Math.min(cards.length - 1, newIndex))
          updateButtons()
          let targetLeft
          if (index === 0) {
            // サブピクセル誤差を避け、先頭は常に厳密な0に固定する
            targetLeft = 0
          } else if (index === cards.length - 1) {
            // 最終カードは右マージン分の余白が見えた状態で止める
            targetLeft = getMaxScrollLeft()
          } else {
            // getBoundingClientRectで画面(ビューポート)基準の実座標を測り、offsetParentのズレの影響を受けないようにする
            const delta = cards[index].getBoundingClientRect().left - getInset()
            targetLeft = Math.max(0, Math.min(track.scrollLeft + delta, getMaxScrollLeft()))
          }
          track.scrollTo({ left: targetLeft, behavior: 'smooth' })
        }

        // スワイプ操作でスクロールされた場合に、止まった位置から現在位置(index)を再計算する
        const syncIndexFromScroll = () => {
          clearTimeout(syncTimer)
          syncTimer = setTimeout(() => {
            const currentLeft = track.scrollLeft
            const maxScrollLeft = getMaxScrollLeft()
            if (currentLeft <= 1) {
              // 左端は末尾カードのマージン分ズレるため、距離計算に頼らず確定させる
              index = 0
            } else if (currentLeft >= maxScrollLeft - 1) {
              // 右端は最終カードのマージン分だけ本来のスナップ位置に届かないため、距離計算に頼らず確定させる
              index = cards.length - 1
            } else {
              let closest = 0
              let closestDistance = Infinity
              cards.forEach((card, i) => {
                const distance = Math.abs((card.offsetLeft - track.offsetLeft) - currentLeft)
                if (distance < closestDistance) {
                  closestDistance = distance
                  closest = i
                }
              })
              index = closest
            }
            updateButtons()
          }, 100)
        }

        prevButton.addEventListener('click', () => goTo(index - 1))
        nextButton.addEventListener('click', () => goTo(index + 1))
        track.addEventListener('scroll', syncIndexFromScroll)
        updateButtons()
      })
    }

    // 定点2025　outline内の注釈(span)が単独行で折り返っている場合だけ余白を付ける
    if (document.body.classList.contains('teiten2025')) {
      const annotationSpans = document.querySelectorAll('.outline p span, .outline p small')

      const checkAloneLine = (span) => {
        const p = span.parentElement
        if (!p) return
        span.classList.remove('is-alone-line')
        const range = document.createRange()
        range.selectNodeContents(p)
        range.setEndBefore(span)
        const precedingRects = range.getClientRects()
        const lastPrecedingRect = precedingRects[precedingRects.length - 1]
        const spanRect = span.getBoundingClientRect()
        const isAloneLine = !lastPrecedingRect || spanRect.top >= lastPrecedingRect.bottom - 1
        span.classList.toggle('is-alone-line', isAloneLine)
      }

      const updateAnnotationSpans = () => annotationSpans.forEach(checkAloneLine)

      updateAnnotationSpans()
      window.addEventListener('resize', updateAnnotationSpans)
      window.addEventListener('load', updateAnnotationSpans)
    }

}

/**
 * Initialize
 */
domReady(main)
